import PropTypes from 'prop-types'

import SearchBar from 'components/SearchBar'
import Select from 'components/Select'

import { ReactComponent as IconFilter } from 'assets/icons/IconFilter.svg'

const DesktopFilters = ({
  handleSetFilter,
  transformedRevenueCenters,
  handleSetSearchQuery,
  onClickFilterBtn,
}) => {
  return (
    <div className="orders-filters">
      <div className="orders-filters__select-wrapper">
        <Select
          id="revenueCenter"
          handleChange={handleSetFilter('revenueCenterUuid')}
          nameClass="-medium"
          label="All Revenue Centers"
          options={transformedRevenueCenters}
        />
      </div>
      <SearchBar id="searchQuery" handleSearch={handleSetSearchQuery} />
      <button className="orders-filters__filter-btn" onClick={onClickFilterBtn}>
        <IconFilter />
      </button>
    </div>
  )
}

DesktopFilters.propTypes = {
  handleSetFilter: PropTypes.func,
  transformedRevenueCenters: PropTypes.array,
  handleSetSearchQuery: PropTypes.func,
  onClickFilterBtn: PropTypes.func,
}

export default DesktopFilters
